// src/UnityComponent.js

import React, { Component, useCallback, useEffect } from 'react';
import { Unity, useUnityContext } from 'react-unity-webgl';
import FadeLoader from 'react-spinners/FadeLoader';
import PropTypes from 'prop-types'; // Import PropTypes
import { connect, useSelector } from 'react-redux';
import { changeTutor, pause, setActiveInstructor } from '../../store/livekit';
import { StartingMethodName, UNITY_MODULE, UnityObjectName } from '../../utils/const';
import LiveKitSDK from '../LiveKit/LiveKitSDK';
import Rooms from '../LiveKit/Rooms';

const path = `unity/out/${UNITY_MODULE}/Build/${UNITY_MODULE}`;

// sendMessage(UnityObjectName, methodName, 100);
// 
// Functional wrapper to handle the Unity context setup with hooks
const UnityLoader = React.memo(({ onUnityProviderReady, onUnityLoaded, setLoadingProgression, onUnityAddEventListener, onRemoveEventListener }) => {
    const { unityProvider, isLoaded, loadingProgression, addEventListener, sendMessage, removeEventListener } = useUnityContext({
        loaderUrl: `/${path}.loader.js`,
        dataUrl: `/${path}.data`,
        frameworkUrl: `/${path}.framework.js`,
        codeUrl: `/${path}.wasm`,
        companyName: "QuikLearn",
        productName: "UnityGame",
        productVersion: "0.1.0",
    });
    const token = useSelector(state => state.auth.token);
    // const dispatch = useDispatch();
    // const messages = useSelector(state => state.livekit.messages);
    // Memoize callbacks to avoid triggering useEffect when not necessary
    const handleUnityProviderReady = useCallback(() => {
        if (unityProvider && onUnityProviderReady) {
            onUnityProviderReady(unityProvider);
            console.log('Parth Unity: Provider is ready');

        }
    }, [unityProvider, onUnityProviderReady]);

    const handleUnityLoaded = useCallback(() => {
        if (isLoaded && onUnityLoaded) {
            onUnityLoaded(isLoaded);
            console.log('Parth Unity: Loaded status changed to', isLoaded);
            if (isLoaded) {
                const msg = {
                    isCustomBot: false,
                    customBotGender: 'parth'
                }
                if (token && token.isCustomBot) {
                    msg.customBotGender = token.characterType
                    msg.isCustomBot = true
                }
                console.log('Parth Unity: Provider is ready', msg);
                sendMessage(UnityObjectName, StartingMethodName, JSON.stringify(msg));
            }
        }
    }, [isLoaded, onUnityLoaded]);

    const handleLoadingProgression = useCallback(() => {
        if (loadingProgression && setLoadingProgression) {
            setLoadingProgression(loadingProgression);
            console.log('Parth Unity: Loading progression is', loadingProgression);
        }
    }, [loadingProgression, setLoadingProgression]);

    const addEventListeners = useCallback(() => {
        if (addEventListener && onUnityAddEventListener) {
            onUnityAddEventListener(addEventListener);
            console.log('Parth Unity: Added event listener');
        }
        addEventListener('SendCommand', (evt) => {
            console.log('Parth SendCommand', evt);
        });
        addEventListener("SendCommand", (...parameters) => {
            console.log("Parth Event 'SendCommand' triggered with parameters:", parameters);

            // Process parameters if needed
            // Return a ReactUnityEventParameter as needed
            return parameters[0]; // Example return, adjust as needed
        });
    }, [addEventListener, onUnityAddEventListener]);

    const removeEventListeners = useCallback(() => {
        if (removeEventListener && onRemoveEventListener) {
            onRemoveEventListener(removeEventListener);
            console.log('Parth Unity: Removed event listener');
        }
    }, [removeEventListener, onRemoveEventListener]);

    // Register event listeners only once when dependencies change
    useEffect(() => {
        addEventListeners();
        return () => removeEventListeners();
    }, [addEventListeners, removeEventListeners]);

    // Handle unityProvider ready state
    useEffect(() => {
        handleUnityProviderReady();
    }, [handleUnityProviderReady]);

    // Handle unity loaded state
    useEffect(() => {
        handleUnityLoaded();
    }, [handleUnityLoaded]);

    // Handle loading progression
    useEffect(() => {
        handleLoadingProgression();
    }, [handleLoadingProgression]);

    return (<>
        <LiveKitSDK sendMessage={sendMessage} />
        <Rooms sendMessage={sendMessage} />

    </>);
    // This component only exists to pass unityProvider up, no UI needed
});

// Add display name
UnityLoader.displayName = 'UnityLoader';
// Define PropTypes for the component
UnityLoader.propTypes = {
    onUnityProviderReady: PropTypes.func,
    onUnityLoaded: PropTypes.func,
    setLoadingProgression: PropTypes.func,
    onUnityAddEventListener: PropTypes.func,
    onRemoveEventListener: PropTypes.func,
};


class UnityComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            unityProvider: null,
            progress: 0,
        };
        console.log('Constructor: Component is being constructed');
    }

    componentDidMount() {
        console.log('componentDidMount: Component has mounted');
        window.addEventListener('message', this.handleMessage);
    }

    componentWillUnmount() {
        console.log('componentWillUnmount: Component is about to unmount');
        window.removeEventListener('message', this.handleMessage);

    }

    handleUnityProviderReady = (unityProvider) => {
        console.log('handleUnityProviderReady: Unity provider is ready', unityProvider);
        this.setState({ unityProvider });
    };

    handleLoadingProgression = (loadingProgression) => {
        const progress = Math.round(loadingProgression * 100);
        console.log('handleLoadingProgression: Loading progression is', progress);
        // this.setState({ progress });
    };

    handleUnityIsLoaded = (isLoaded) => {
        console.log('handleUnityIsLoaded: Unity loaded status', isLoaded);
        if (isLoaded) {
            this.setState({ loading: false });
        }
    };

    // handleUnityAddEventListener = (addEventListener) => {
    //     console.log('handleUnityAddEventListener: Adding event listener');
    //     // addEventListener('SendCommand', this.handleMessage);

    //     // addEventListener('Start', this.startTutorSession);

    //     // addEventListener('Stop', this.stopTutorSession);

    //     // addEventListener('ChangeTutor', this.changeTutor);

    // };

    // handleRemoveEventListener = (removeEventListener) => {
    //     console.log('handleRemoveEventListener: Removing event listener');
    //     // removeEventListener('SendCommand', this.handleMessage);

    // };

    startTutorSession = (tutorName) => {
        console.log('Starting tutor session with:', tutorName);
        // Add logic to start session, e.g., initialize connections, update state
        this.props.setInstructorAction(tutorName)
    };

    changeTutor = (newTutorName) => {
        console.log('Changing tutor to:', newTutorName);
        this.props.pauseAction();
        // Add logic for changing the tutor, e.g., update state, notify Unity
        this.props.changeTutorAction(newTutorName);
    };

    stopTutorSession = (tutorName) => {
        console.log('Stopping tutor session for:', tutorName);
        // Add logic to stop session, e.g., disconnect room, update state
        this.props.pauseAction()
    };
    handleMessage = (evt) => {
        console.log('Message from Unity:', evt);

        try {
            const { data } = evt;
            const { command: commandName, value: payload, route } = data;
            if (route === "SendCommand") {

                switch (commandName) {
                    case 'Start':
                        this.startTutorSession(payload);
                        break;
                    case 'ChangeTutor':
                        this.changeTutor(payload);
                        break;
                    case 'Stop':
                        this.stopTutorSession(payload);
                        break;
                    default:
                        console.warn(`Unknown command: ${commandName}`);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        // Only re-render if loading, unityProvider or progress has changed
        return (
            this.state.loading !== nextState.loading ||
            this.state.unityProvider !== nextState.unityProvider ||
            this.state.progress !== nextState.progress
        );
    }


    render() {
        console.log('Render: Component is rendering');
        const { loading, unityProvider,
            // progress 
        } = this.state;
        // console.log('Current progress:', progress);

        return (
            <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
                {loading && (
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        }}
                    >
                        <FadeLoader color="#c5e836" size={50} />

                        {/* <Spinner size={50} strokeWidth={15} color="#3498db" progress={progress} /> */}
                    </div>
                )}

                <UnityLoader
                    // onRemoveEventListener={this.handleRemoveEventListener}
                    // onUnityAddEventListener={this.handleUnityAddEventListener}
                    setLoadingProgression={this.handleLoadingProgression}
                    onUnityProviderReady={this.handleUnityProviderReady}
                    onUnityLoaded={this.handleUnityIsLoaded}
                />

                {unityProvider && (
                    <Unity
                        unityProvider={unityProvider}
                        style={{ width: '100%', height: '100%' }}
                    />
                )}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // explicitly forwarding arguments
        setInstructorAction: (event) => dispatch(setActiveInstructor(event)),
        pauseAction: () => dispatch(pause()),
        changeTutorAction: (params) => dispatch(changeTutor(params))
    }
}

UnityComponent.propTypes = {
    setInstructorAction: PropTypes.func,
    pauseAction: PropTypes.func,
    changeTutorAction: PropTypes.func
};
export default connect(null, mapDispatchToProps)(UnityComponent);
